import { useState } from "react"
import { Check, X } from "lucide-react"

// The just-subscribed confirmation strip (welcome state). The presenter only
// resolves the welcome state on a ?checkout=ok Stripe return, so this shows
// once per subscribe and dismisses for the visit.
export default function WelcomeFlash() {
  const [dismissed, setDismissed] = useState(false)
  if (dismissed) return null

  return (
    <div role="status" className="flex items-center gap-[12px] rounded-xl border border-done/25 bg-done/10 py-[10px] pr-[12px] pl-[14px] text-[13.5px] text-foreground">
      <span className="flex size-[26px] shrink-0 items-center justify-center rounded-[8px] bg-done text-background">
        <Check className="size-[14px]" strokeWidth={2.8} />
      </span>
      <div>
        <b className="font-semibold">Welcome to Insider.</b> Your locked Insider rates now apply to every new order.
      </div>
      <button type="button" aria-label="Dismiss" onClick={() => setDismissed(true)} className="ml-auto shrink-0 p-[4px] text-ink-3 hover:text-foreground">
        <X className="size-4" strokeWidth={2.2} />
      </button>
    </div>
  )
}
